import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';
import en from './locales/en.json';

// Misma key que ya se usaba en localStorage antes (ModalLanguage.jsx / ModalKioskLanguage.jsx),
// asi el idioma elegido previamente por el usuario se respeta sin migracion de datos.
export const LANG_STORAGE_KEY = 'lang';

export const DEFAULT_LANGUAGE = 'es';

const resources = {
  es: { translation: es },
  en: { translation: en }
};

const getStoredLanguage = () => {
  try {
    const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
    return stored && resources[stored] ? stored : DEFAULT_LANGUAGE;
  } catch (err) {
    return DEFAULT_LANGUAGE;
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false
    },
    returnEmptyString: false
  });

/**
 * Function to change the active language app-wide.
 * Persists the choice in localStorage (same key the app already used) and
 * updates i18next, which re-renders every component using useTranslation().
 * @param {*} languageCode e.g. 'es', 'en'
 */
export const changeLanguage = (languageCode) => {
    try {
        window.localStorage.setItem(LANG_STORAGE_KEY, languageCode);
    } catch (err) {
        // localStorage no disponible, seguimos igual con el cambio en memoria
    }
    return i18n.changeLanguage(languageCode);
};

/**
 * Function to read the currently selected language, used by the axios
 * interceptor to tag every request with ?lang= for translated backend data.
 * @returns {string}
 */
export const getCurrentLanguage = () => getStoredLanguage();

export default i18n;
